import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "status"]

  connect() {
    if (this.containerTarget.children.length === 0) this.add()
  }

  add() {
    return this.appendRow()
  }

  appendRow({ name = "", files = [] } = {}) {
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.nextIndex())
    const wrapper = document.createElement("div")
    wrapper.innerHTML = html.trim()
    const row = wrapper.firstChild
    this.containerTarget.appendChild(row)

    if (name) {
      const nameInput = row.querySelector('[data-lookbook-looks-target="nameInput"]')
      if (nameInput) nameInput.value = name
    }
    if (files.length) {
      const filesInput = row.querySelector('[data-lookbook-looks-target="filesInput"]')
      const summary = row.querySelector('[data-lookbook-looks-target="fileSummary"]')
      const dt = new DataTransfer()
      files.forEach((f) => dt.items.add(f))
      filesInput.files = dt.files
      if (summary) summary.textContent = `${files.length} file${files.length === 1 ? "" : "s"} attached`
    }
    return row
  }

  remove(event) {
    const row = event.currentTarget.closest(".lookbook-looks__row")
    if (row) row.remove()
  }

  nextIndex() {
    return this.containerTarget.children.length
  }

  pickFolder(event) {
    const input = event.currentTarget
    const files = Array.from(input.files || []).filter(this.isImage)
    if (!files.length) return

    const groups = this.groupByFirstSegment(files)
    const lookNames = Object.keys(groups)
    if (!lookNames.length) return

    this.clearEmptyRows()

    lookNames.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }))
    lookNames.forEach((name) => this.appendRow({ name, files: groups[name] }))

    if (this.hasStatusTarget) {
      const totalFiles = files.length
      this.statusTarget.textContent =
        `${lookNames.length} look${lookNames.length === 1 ? "" : "s"} detected · ${totalFiles} picture${totalFiles === 1 ? "" : "s"} attached`
    }

    // Reset the picker so the same folder can be re-picked if needed.
    input.value = ""
  }

  isImage(file) {
    return /^image\/(jpeg|png|webp)$/.test(file.type) || /\.(jpe?g|png|webp)$/i.test(file.name)
  }

  groupByFirstSegment(files) {
    const groups = {}
    files.forEach((file) => {
      const path = file.webkitRelativePath || file.name
      const parts = path.split("/")
      // Path shape: "<parent>/<look>/.../file.jpg" — group by the look folder.
      // If only "<file.jpg>" with no parent, treat as a single "Untitled" look.
      const lookKey = parts.length >= 3 ? parts[1] : parts.length === 2 ? parts[0] : "Untitled look"
      ;(groups[lookKey] ||= []).push(file)
    })
    return groups
  }

  clearEmptyRows() {
    Array.from(this.containerTarget.children).forEach((row) => {
      const nameInput = row.querySelector('[data-lookbook-looks-target="nameInput"]')
      const filesInput = row.querySelector('[data-lookbook-looks-target="filesInput"]')
      const empty = (!nameInput || !nameInput.value.trim()) && (!filesInput || !filesInput.files || !filesInput.files.length)
      if (empty) row.remove()
    })
  }
}
